export default "__VITE_ASSET__xqw7p1f5__"